import { FC, lazy } from 'react';
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import { PrivateRoutes } from './PrivateRoutes';

import App from '../App';
import { AuthPage } from '../app/auth/AuthPage';
import { useAuth } from '../app/auth';
const AboutUs = lazy(() => import('../features/about/About'));
const { PUBLIC_URL } = process.env;
const AppRoutes: FC = () => {
  // const isAuthenticated = localStorage.getItem("a") !== null;
  const { currentUser } = useAuth();

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          {/* <Route path='auth/*' element={<AuthPage />} /> */}
          {/* <Route path='logout' element={<Logout />} /> */}
          <Route path='/about' element={<AboutUs />} />
          {/* <Route path='/auth' element={<Login />} /> */}
          {currentUser?.username ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export { AppRoutes };
